import { Menu, MenuListItem, IconButton, IconMoreVert } from 'cdk-radial';
import React, {useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getURL} from '../../../../redux/connectedComponent/provisionSettings/provisionSettings.slice';
import VerifyAccount from '../../../common/verifyAccount/verifyAccount';
import { sendAmplitudeData } from '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';

const CustomMenu = (props) => {
  
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const loginDetailsState  = state && state.loginDetailsSlice;
    let token = (loginDetailsState && loginDetailsState.authenticationToken) || '';
    
    const { gridParams } = props;
    const { data } = gridParams;
    const { pendingAccountInfo = {} } = data;
    const solutionData = data.solutionData;
    const subscriptionData = data.subscriptionData;
    const handleCancelSubscription = data.handleCancelSubscription;

    const targetRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState({});
    const [isVerifyAccDialogOpen, setIsVerifyAccDialogOpen] = useState(false)

    const appActivation = (subscriptionData && subscriptionData.length && subscriptionData[0].appSubscriptionActivationType) || 'Automatic';
    const redirectUrl = solutionData && solutionData.provisioning_interface && solutionData.provisioning_interface.redirectURL;
    const entityIdRedirection = solutionData && solutionData.provisioning_interface && solutionData.provisioning_interface.entityID && solutionData.provisioning_interface.entityID  === true;
    
    const options = [
      { label: 'Cancel' }
    ];

    if(redirectUrl && !(appActivation === 'Manual' && !entityIdRedirection)){
        options.splice(0, 0, {label : 'Configure App'});
    }

    if(pendingAccountInfo.isPendingAccountVerification){
        options.push({label: 'Verify Account'})
    }

    const handleClose = (event) => {
      setIsOpen(false);
    };
  
    const handleOpen = (event) => {
      setIsOpen(true);
    };

    const amplitudeUtilityFunction = (event) => {

      sendAmplitudeData(event,{
        [AMPLITUDE_PROPERTIES.APP_NAME] : solutionData?.overview?.name || solutionData?.displayName,
        [AMPLITUDE_PROPERTIES.APP_ID]: solutionData?.id
      });
    }
  
    const handleSelect = (option) => {
        setSelectedOption(option);
        if(option.label === 'Cancel'){
            amplitudeUtilityFunction(AMPLITUDE_EVENTS.SELECT_CANCEL_SUBSCRIPTION);
            handleCancelSubscription(subscriptionData, solutionData)
          }
        else if (option.label === 'Configure App') {
            amplitudeUtilityFunction(AMPLITUDE_EVENTS.CONFIGURE_APP);
            let subscriptionIds = subscriptionData && subscriptionData.length && subscriptionData.map(subscription => subscription && subscription.subscriptionId);
            let entityIds = subscriptionData && subscriptionData.length && subscriptionData.map(subscription => subscription && subscription.entityId);
            if (entityIdRedirection) 
            {
                dispatch(getURL({url: redirectUrl,type:'entityId', ids:entityIds.join(), token}));
            }
            else if(subscriptionIds.length){
                dispatch(getURL({url: redirectUrl,type:'subscriptionId', ids:subscriptionIds.join(), token}));
            }
            }
        else if(option.label === 'Verify Account'){
            setIsVerifyAccDialogOpen(true)
        }
        setIsOpen(false);
    };
  
    return (
      <>
        <IconButton
          icon={<IconMoreVert />}
          dataTestId="button"
          ref={targetRef}
          text=""
        />        
        <Menu 
          dataTestId="pending-subscription-menu-container" 
          labelRef={targetRef} 
          onClose={handleClose} 
          onOpen={handleOpen} 
          isAuto={true} 
        >
          {options.map((option, ind) => (
            <MenuListItem
              dataTestId={`pending-subscription-menu-item-${ind}`}
              isSelected={selectedOption.label === option.label}
              key={ind}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </MenuListItem>
          ))}
        </Menu>
        {
        pendingAccountInfo.isPendingAccountVerification &&
            <VerifyAccount
                solutionId={pendingAccountInfo.pendingOrgInfo.solutionId}
                orgId={pendingAccountInfo.pendingOrgInfo.entityId}
                customerRef={pendingAccountInfo.pendingOrgInfo.customerRef}
                open={isVerifyAccDialogOpen}
                setIsVerifyAccDialogOpen={setIsVerifyAccDialogOpen}
            />
        }
      </>
    );
  };

export default CustomMenu;